<template>

  <div>
    <div class="messages" v-show="showBox" key="messages" v-loading="loading">
      <div class="titolo col-24 no-padding">
        {{ $t('messages.messaggi').toUpperCase() }}
        &emsp;

        <icon class="pointer" name="riv-reload" scale="1" @click.native="getMessaggi"></icon>

      </div>

      <el-tabs v-model="activeTab" class="tabs-class custom-tabs" :style="{ height: height + 'px' }">
        <el-tab-pane name="messaggi" :key="($t('messages.messaggi') + ' ' + counterNonLetti)">
          <div slot="label">
            <div class="col-24 no-padding counter-nuovi">
              <el-badge :value="counterNonLetti" class="item" :hidden="(counterNonLetti <= 0)">
                {{ $t('messages.messaggi') }}
              </el-badge>
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>

          <div v-for="(messaggio, index) in messaggi" class="messaggio" :key="index" :class="{ important: isImportant(messaggio) }">
            <div class="testata col-24">
              <div class="titolo">
                {{ messaggio.titolo }}
              </div>
              <div class="priorita" v-if="(messaggio.priorita === '1')">
                <icon name="riv-preferitiFull" scale="0.8"></icon>
              </div>
              <div class="allegati" v-if="(messaggio.allegati.length > 0)">
                <icon name="riv-attach" scale="1"></icon>
              </div>
              <div class="presa-vis" v-if="(messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'N')">
                <icon name="riv-acceptView" scale="1"></icon>
              </div>
               <div class="presa-vis-yes" v-if="(messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'Y')">
                <icon name="riv-read" scale="1"></icon>
              </div>
            </div>
            <div class="col-24 testo truncate" v-html="messaggio.testo"></div>
            <div class="footer col-24">
              <div class="data">
                {{ $t('messages')[new Date(messaggio.dataPub.substr(0, 4), parseInt(messaggio.dataPub.substr(5, 2)) - 1, messaggio.dataPub.substr(8, 2)).getDay()] + ', ' + moment(messaggio.dataPub, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
              </div>
              <el-button class="WEB-button WEB-button-header" @click="openMessageModal(true, messaggio)">{{ $t('messages.leggi') }}</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="annunci" :key="($t('messages.annunci') + ' ' + counterAnnunci)">
          <div slot="label">
            <div class="col-24 no-padding counter-bacheca">
              <el-badge :value="counterAnnunciNonLetti" class="item" :hidden="(counterAnnunciNonLetti <= 0)">
                {{ $t('messages.annunci') + ((counterAnnunci > 0) ? (' (' + counterAnnunci + ')') : '') }}
              </el-badge>
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>

          <div v-for="(messaggio, index) in messaggiAnnunci" class="messaggio" :key="index" :class="{ important: isImportant(messaggio) }">
            <div class="testata col-24">
              <div class="titolo">

                {{ messaggio.titolo }}
              </div>
              <div class="priorita" v-if="(messaggio.priorita === '1')">
                <icon name="riv-preferitiFull" scale="0.8"></icon>
              </div>
              <div class="allegati" v-if="(messaggio.allegati.length > 0)">
                <icon name="riv-attach" scale="1"></icon>
              </div>
              <div class="presa-vis" v-if="(messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'N')">
                <icon name="riv-acceptView" scale="1"></icon>
              </div>
               <div class="presa-vis-yes" v-if="(messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'Y')">
                <icon name="riv-read" scale="1"></icon>
              </div>
            </div>
            <div class="col-24 testo truncate" v-html="messaggio.testo"></div>
            <div class="footer col-24">
              <div class="data">
                {{ $t('messages.scade') + ' ' + moment(messaggio.dataExp, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
              </div>
              <el-button class="WEB-button WEB-button-header" @click="openMessageModal(false, messaggio)">{{ $t('messages.leggi') }}</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="notifiche" :key="($t('messages.notifiche') + ' ' + counterNotifiche)">
          <div slot="label">
            <div class="col-24 no-padding counter-nuovi">
              <el-badge :value="counterNotifiche" class="item" :hidden="(counterNotifiche <= 0)">
                {{ $t('messages.notifiche') }}
              </el-badge>
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>

          <div v-for="(messaggio, index) in notifiche" class="messaggio" :key="index" :class="{ important: isImportant(messaggio, 'NOTIFICHE') }">
            <div class="testata col-24">
              <div class="titolo">
                {{ messaggio.title ? messaggio.title.toUpperCase() : '' }}
              </div>
            </div>
            <div class="col-24 testo truncate" v-html="messaggio.body"></div>
            <div class="footer col-24">
              <div class="data">
                {{ 
                  $t('messages')[moment(messaggio.dataInvio, 'YYYY-MM-DD-HH.mm').day()] 
                  + ', ' + 
                  moment(messaggio.dataInvio, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') 
                }}
              </div>
              <el-button class="WEB-button WEB-button-header" @click="openNotificaModal(messaggio)">{{ $t('messages.leggi') }}</el-button>
            </div>
          </div>
          <div>
            <el-button class="WEB-button WEB-button-header" style="width: calc(100% - 10px) !important" @click="setNotificaService(null, 'Y')">{{ $t('messages.leggiTutti') }}</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog class="modal-message" :visible.sync="messageDialogVisible" @close="getMessaggi"
               width="600px" :append-to-body="true" 
               :title="msg.titolo.toUpperCase()" custom-class="custom-dialog">

      <div class="col-24 no-padding data">
        {{ $t('messages')[new Date(msg.dataPub.substr(0, 4), parseInt(msg.dataPub.substr(5, 2)) - 1, msg.dataPub.substr(8, 2)).getDay()] + ', ' + moment(msg.dataPub, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
      </div>
      <div class="col-24 no-padding data" v-if="(msg.hasOwnProperty('dataExp'))">
        {{ $t('messages.scade') + ' ' + moment(msg.dataExp, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
      </div>
      <!--<div class="priorita col-24 no-padding" v-if="(msg.priorita === '1' && !msg.hasOwnProperty('dataExp'))">
        <span class="prior-label">
          {{ $t('messages.priorita.label') + ': ' }}
        </span>
        <span class="prior-value">
          {{ $t('messages.priorita')[msg.priorita].toUpperCase() }}
        </span>
        <span class="prior-icon">
          <icon name="riv-preferitiFull" scale="0.8"></icon>
        </span>
      </div>-->
      <div class="testo col-24 no-padding" v-html="msg.testo"></div>
      <div class="allegati col-24 no-padding" v-if="(msg.allegati.length > 0)">
        <div v-for="mess in msg.allegati" :key="mess.keyDoc">
          <div class="col-24 no-padding allegato" @click="getAllegato(mess)">
            <icon class="icona" name="riv-attach" scale="1"></icon>
            <div class="titolo-allegato">
              {{ mess.titolo }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer">
        <div class="col-24 no-padding">
          <!--<el-button class="custom-button" type="primary" v-if="(!msg.hasOwnProperty('dataExp'))" @click="setMessaggioService(msg, 'C')">
            {{ $t('messages.elimina').toUpperCase() }}
          </el-button>-->
          <el-button class="WEB-button WEB-button-primary" v-if="(msg.sePresaVis === 'Y' && msg.presaVis === 'N')" @click.native="setMessaggioService(msg, 'P', true)">
            {{ $t('messages.presaVisione').toUpperCase() }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="modal-message" :visible.sync="notificheDialogVisible"
               width="600px" :append-to-body="true" 
               :title="notifica.title.toUpperCase()" custom-class="custom-dialog">

      <div class="col-24 no-padding data">
        {{ $t('messages')[new Date(notifica.dataInvio.substr(0, 4), parseInt(notifica.dataInvio.substr(5, 2)) - 1, notifica.dataInvio.substr(8, 2)).getDay()] + ', ' + moment(notifica.dataInvio, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
      </div>
      <div class="col-24 no-padding data" v-if="(notifica.hasOwnProperty('dataExp'))">
        {{ $t('messages.letta') + ' ' + moment(notifica.dataLettura, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
      </div>
      <div class="testo col-24 no-padding" v-html="notifica.body"></div>
      <div slot="footer" class="footer">
        <div class="col-24 no-padding">
          <!--<el-button class="custom-button" type="primary" v-if="(!msg.hasOwnProperty('dataExp'))" @click="setMessaggioService(msg, 'C')">
            {{ $t('messages.elimina').toUpperCase() }}
          </el-button>-->
          <el-button class="WEB-button WEB-button-alternative" @click.native="closeNotificaModal()">
            {{ $t('btn.close').toUpperCase() }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="modalMessaggi" @close="closeMessages"
               custom-class="custom-dialog offset-xl-5 col-xl-14 offset-lg-4 col-lg-16 offset-md-2 col-md-20 offset-0 col-24"
               :append-to-body="true" key="dialog"
               :visible.sync="showModal">

      <span slot="title">
        {{ $t('messages.messaggi').toUpperCase() }}
        &emsp;

        <icon class="pointer" name="riv-reload" scale="1" @click.native="getMessaggi"></icon>

      </span>

      <div v-loading="loading">
        <el-tabs v-model="activeTab" class="custom-tabs tabs-class" @tab-click="changeTab">
          <el-tab-pane name="messaggi" :key="($t('messages.messaggi') + ' ' + counterNonLetti)">
            <div slot="label">
              <div class="col-24 no-padding counter-nuovi">
                <el-badge :value="counterNonLetti" class="item" :hidden="(counterNonLetti <= 0)">
                  {{ $t('messages.messaggi') }}
                </el-badge>
              </div>
              <div class="col-24 no-padding barra"></div>
            </div>

            <div class="row row-custom">
              <div class="col-8 no-padding elenco-messaggi">
                <el-card class="col-24" v-for="(item, index) in messaggi"
                         :key="index" shadow="never"
                         :class="{selected: (messaggio.id === item.id), important: isImportant(item)}" @click.native="selectMessage(item, index)">
                  <div class="testata col-24">
                    <div class="titolo">
                      {{ item.titolo ? item.titolo.toUpperCase() : '' }}
                    </div>
                    <div class="priorita" v-if="(item.priorita === '1')">
                      <icon name="riv-preferitiFull" scale="0.8"></icon>
                    </div>
                    <div class="allegati" v-if="(item.allegati.length > 0)">
                      <icon name="riv-attach" scale="1"></icon>
                    </div>
                    <div class="presa-vis" v-if="(item.sePresaVis === 'Y' && item.presaVis === 'N')">
                      <icon name="riv-acceptView" scale="1"></icon>
                    </div>
                      <div class="presa-vis-yes" v-if="(item.sePresaVis === 'Y' && item.presaVis === 'Y')">
                      <icon name="riv-read" scale="1"></icon>
                    </div>
                  </div>
                  <div class="col-24 testo truncate" v-html="item.testo"></div>
                  <div class="footer col-24 no-padding">
                    <div class="data">
                      {{ formattedMessageDate(item) }}
                    </div>
                    <div class="skip" v-if="(item.seSkip === 'Y')">
                      <el-badge :value="'(' + item.numSkip + ')'" class="item" :hidden="(item.numSkip === '' || item.numSkip <= 0 )">
                        <icon name="riv-skip" scale="1"></icon>
                      </el-badge>
                    </div>
                  </div>
                </el-card>
              </div>
              <div class="col-16 area-messaggio">
                <div class="col-24 msg" v-if="showMessaggio">
                  <div class="titolo col-24 no-padding">
                    {{ messaggio.titolo ? messaggio.titolo.toUpperCase() : '' }}
                  </div>
                  <div class="data col-24 no-padding">
                    {{ formattedMessageDate(messaggio) }}
                  </div>
                  <div class="priorita col-24 no-padding" v-if="(messaggio.priorita === '1')">
                    <span class="prior-label">
                      {{ $t('messages.priorita.label') + ': ' }}
                    </span>
                    <span class="prior-value">
                      {{ $t('messages.priorita')[messaggio.priorita].toUpperCase() }}
                    </span>
                    <span class="prior-icon">
                      <icon name="riv-preferitiFull" scale="0.8"></icon>
                    </span>
                  </div>
                  <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
                  <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
                    <div v-for="msg in messaggio.allegati" :key="msg.keyDoc">
                      <div class="col-24 no-padding allegato" @click="getAllegato(msg)">
                        <icon class="icona" name="riv-attach" scale="1"></icon>
                        <div class="titolo-allegato">
                          {{ msg.titolo }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="messaggio-footer col-24 no-padding" v-if="(messaggio.id !== undefined)">
                    <el-button v-if="(messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'N')" @click=" setMessaggioService(messaggio, 'P', false)" class="WEB-button WEB-button-primary">
                      {{ $t('messages.presaVisione').toUpperCase() }}
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="annunci" :key="($t('messages.annunci') + ' ' + counterAnnunci)">
            <div slot="label">
              <div class="col-24 no-padding counter-bacheca">
                <el-badge :value="counterAnnunciNonLetti" class="item" :hidden="(counterAnnunciNonLetti <= 0)">
                   {{ $t('messages.annunci') + ((counterAnnunci > 0) ? (' (' + counterAnnunci + ')') : '') }}
                </el-badge>
              </div>
              <div class="col-24 no-padding barra"></div>
            </div>

            <div class="row row-custom">
              <div class="col-8 no-padding elenco-messaggi">
                <el-card class="col-24" v-for="(item, index) in messaggiAnnunci"
                         :key="index" shadow="never"
                         :class="{selected: (messaggio.id === item.id), important: isImportant(item)}" @click.native="selectMessage(item, index)">
                  <div class="testata col-24">
                    <div class="titolo">
                       {{ item.titolo ? item.titolo.toUpperCase() : '' }}
                    </div>
                    <div class="allegati" v-if="(item.allegati.length > 0)">
                      <icon name="riv-attach" scale="1"></icon>
                    </div>
                    <div class="presa-vis" v-if="(item.sePresaVis === 'Y' && item.presaVis === 'N')">
                      <icon name="riv-acceptView" scale="1"></icon>
                    </div>
                      <div class="presa-vis-yes" v-if="(item.sePresaVis === 'Y' && item.presaVis === 'Y')">
                      <icon name="riv-read" scale="1"></icon>
                    </div>
                  </div>
                  <div class="col-24 testo truncate" v-html="item.testo"></div>
                  <div class="footer col-24 no-padding">
                    <div class="data">
                      {{ $t('messages.scade') + ' ' + moment(item.dataExp, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
                    </div>
                    <div class="skip" v-if="(item.seSkip === 'Y')">
                      <el-badge :value="'(' + item.numSkip + ')'" class="item" :hidden="(item.numSkip === '' || item.numSkip <= 0 )">
                        <icon name="riv-skip" scale="1"></icon>
                      </el-badge>
                    </div>
                  </div>
                </el-card>
              </div>
              <div class="col-16 area-messaggio">
                <div class="col-24 msg" v-if="showMessaggio">
                  <div class="titolo col-24 no-padding">
                    {{ messaggio.titolo ? messaggio.titolo.toUpperCase() : '' }}
                  </div>
                  <div class="data col-24 no-padding">
                    {{ formattedMessageDate(messaggio) }}
                  </div>
                  <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
                  <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
                    <div v-for="msg in messaggio.allegati" :key="msg.keyDoc">
                      <div class="col-24 no-padding allegato" @click="getAllegato(msg)">
                        <icon class="icona" name="riv-attach" scale="1"></icon>
                        <div class="titolo-allegato">
                          {{ msg.titolo }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="notifiche" :key="($t('messages.letti') + ' ' + counterNotifiche)">
            <div slot="label">
              <div class="col-24 no-padding counter-nuovi">
                <el-badge :value="counterNotifiche" class="item" :hidden="(counterNotifiche <= 0)">
                  {{ $t('messages.notifiche') }}
                </el-badge>
              </div>
              <div class="col-24 no-padding barra"></div>
            </div>
            <div class="row row-custom">
              <div class="col-8 no-padding elenco-messaggi">
                <el-card class="col-24" v-for="(item, index) in notifiche"
                         :key="index" shadow="never"
                         :class="{selected: (messaggio.idNotifica === item.idNotifica), important: isImportant(item, 'NOTIFICHE')}" @click.native="selectNotifica(item, index)">
                  <div class="testata col-24">
                    <div class="titolo">
                      {{ item.title ? item.title.toUpperCase() : '' }}
                    </div>
                  </div>
                  <div class="col-24 testo truncate" v-html="item.body"></div>
                  <div class="footer col-24 no-padding">
                    <div class="data">
                      {{ formattedNotificationDate(item) }}
                    </div>
                  </div>
                </el-card>
                <div>
                  <el-button class="WEB-button WEB-button-header" style="width: calc(100% - 10px) !important" @click="setNotificaService(null, 'Y')">{{ $t('messages.leggiTutti') }}</el-button>
                </div>
              </div>
              <div class="col-16 area-messaggio">
                <div class="col-24 msg" v-if="showNotifica">
                  <div class="titolo col-24 no-padding">
                    {{ messaggio.title ? messaggio.title.toUpperCase() : '' }}
                  </div>
                  <div class="data col-24 no-padding">
                    {{ formattedNotificationDate(messaggio) }}
                  </div>
                  <div class="testo col-24 no-padding" v-html="messaggio.body"></div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  import moment from 'moment'
  import { bus } from './Bus'
  import mixinDownload from "../assets/mixins/downloadDoc.js";

  export default {
    name: 'Messages',
    mixins: [mixinDownload],
    props: {
      height: {
        type: Number,
        required: true,
        default: 550
      },
      showMessages: {
        type: Object,
        required: true,
        default: function () {
          let obj = {
            val: false,
            type: 1
          }
          return obj
        }
      }
    },
    i18n: {
      messages: {
        it_IT: {
          messages: {
            nuovi: 'Nuovi',
            letti: 'Letti',
            bacheca: 'Bacheca',
            annunci: 'Annunci',
            messaggi: 'Messaggi',
            notifiche: 'Notifiche',
            noMsg: 'Nessun messaggio',
            1: 'Lunedì',
            2: 'Martedì',
            3: 'Mercoledì',
            4: 'Giovedì',
            5: 'Venerdì',
            6: 'Sabato',
            0: 'Domenica',
            leggi: 'Leggi',
            leggiTutti: 'Leggi Tutti',
            priorita: {
              label: 'Priorità',
              1: 'Alta'
            },
            elimina: 'Elimina',
            scade: 'Scade il',
            ricevuto: 'Ricevuto il',
            presaVisione: 'Presa Visione',
            letta: 'Letta il',
          }
        },
        fr_FR: {
          messages: {
            nuovi: 'Nouveau',
            letti: 'Lu',
            bacheca: 'Petites Ann.',
            annunci: 'Annonces',
            messaggi: 'Messages',
            notifiche: 'Notifications',
            noMsg: 'Pas de message',
            1: 'Lundi',
            2: 'Mardi',
            3: 'Mercredi',
            4: 'Jeudi',
            5: 'Vendredi',
            6: 'Sabbat',
            0: 'Dimanche',
            leggi: 'Lire',
            priorita: {
              label: 'Priorité',
              1: 'Haute'
            },
            elimina: 'Éliminer',
            scade: 'Expire le',
            ricevuto: 'Reçu le',
            presaVisione: 'Pris connaissance',
            letta: 'Lu le',
          }
        },
        es_ES: {
          messages: {
            nuovi: 'Nuevos',
            letti: 'Leidos',
            bacheca: 'Prioritari',
            annunci: 'Anuncios',
            messaggi: 'Mensajes',
            notifiche: 'Notificaciones',
            noMsg: 'Sin mensaje',
            1: 'Lunes',
            2: 'Martes',
            3: 'Miércoles',
            4: 'Jueves',
            5: 'Viernes',
            6: 'Sábado',
            0: 'Domingo',
            leggi: 'Leer',
            priorita: {
              label: 'Prioridad',
              1: 'Alto'
            },
            elimina: 'Eliminar',
            scade: 'Vence el',
            ricevuto: 'Recibido el',
            presaVisione: 'Tomado conocimiento',
            letta: 'Leído el',
          }
        },
        de_DE: {
          messages: {
            nuovi: 'Neu',
            letti: 'Gelesen',
            bacheca: 'Schwarzes Brett',
            annunci: 'Anzeigen',
            messaggi: 'Beiträge',
            notifiche: 'Benachrichtigungen',
            noMsg: 'Keine nachricht',
            1: 'Montag',
            2: 'Dienstag',
            3: 'Mittwoch',
            4: 'Donnerstag',
            5: 'Freitag',
            6: 'Sabbat',
            0: 'Sonntag',
            leggi: 'Lesen',
            priorita: {
              label: 'Priorität',
              1: 'Hoch'
            },
            elimina: 'Beseitigen',
            scade: 'Läuft am ab',
            ricevuto: 'Eingegangen am',
            presaVisione: 'Zur Kenntnis genommen',
            letta: 'Gelesen am',
          }
        },
        en_GB: {
          messages: {
            nuovi: 'New',
            letti: 'Read',
            bacheca: 'Notice Board',
            annunci: 'Annunci',
            messaggi: 'Messages',
            notifiche: 'Notifications',
            noMsg: 'No messages',
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday',
            0: 'Sunday',
            leggi: 'Read',
            priorita: {
              label: 'Priority',
              1: 'High'
            },
            elimina: 'Remove',
            scade: 'Expires',
            ricevuto: 'Received on',
            presaVisione: 'Taken note of',
            letta: 'Read on',
          }
        }
      }
    },
    data () {
      return {
        moment: moment,
        loading: true,
        activeTab: 'messaggi',
        msg: {
          titolo: '',
          dataPub: '',
          dataExp: '',
          testo: '',
          allegati: []
        },
        notifica: {
          title: '',
          body: '',
          dataInvio: '',
          dataLettura: ''
        },
        messaggio: {},
        showMessaggio: false,
        showNotifica: false,
        messageDialogVisible: false,
        notificheDialogVisible: false,
        messaggi: [],
        messaggiLetti: [],
        messaggiBacheca: [],
        messaggiNonLetti: [],
        messaggiAnnunci: [],
        notifiche: [],
        counterLetti: 0,
        counterBacheca: 0,
        counterNonLetti: 0,
        counterAnnunci: 0,
        counterAnnunciNonLetti: 0,
        counterNotifiche: 0,
        codLang: (sessionStorage.hasOwnProperty('codLang')) ? (sessionStorage.getItem('codLang')) : 'it_IT',
        token: sessionStorage.getItem('token_download')
      }
    },
    filters: {
    },
    computed: {
      showModal: {
        get: function () {
          return (this.showMessages.val && this.showMessages.type === 1)
        },
        set: function (newValue) {
          //
        }
      },
      showBox: function () {
        return (this.showMessages.val && this.showMessages.type === 0)
      }
    },
    mounted: function () {
      this.getMessaggi(true)
      this.loading = false
      bus.$on('reloadMessaggi', () => {this.getMessaggi()})
    },
    methods: {
      getMessaggi: function (mount) {
        this.$set(this, 'loading', true)
        setTimeout(() => {
          let msg = {
            titolo: '',
            dataPub: '',
            dataExp: '',
            testo: '',
            allegati: []
          }
          this.$set(this, 'messaggio', msg)
          this.$set(this, 'msg', msg)
          this.$http.get('dashboard/' + this.$store.state.country + '/lstmessaggi', {
            params: {}
          })
            .then(response => {
              if (response.body.rc === 0) {
                this.$set(this, 'messaggi', [...response.body.data.nonLetti, ...response.body.data.letti])
                //this.$set(this, 'messaggiNonLetti', response.body.data.nonLetti)
                //this.$set(this, 'messaggiLetti', response.body.data.letti)
                this.$set(this, 'messaggiAnnunci', response.body.data.annunci)
                this.$set(this, 'notifiche', response.body.data.notifiche)
                this.$set(this, 'counterNonLetti', parseInt(response.body.attrib.nonLetti))
                this.$set(this, 'counterLetti', parseInt(response.body.attrib.letti))
                this.$set(this, 'counterAnnunci', parseInt(response.body.attrib.annLetti) + parseInt(response.body.attrib.annNonLetti))
                this.$set(this, 'counterAnnunciNonLetti', parseInt(response.body.attrib.annNonLetti))
                this.$set(this, 'counterNotifiche', parseInt(response.body.attrib.notNonLette))
                this.$emit('changeCounterNuovi', parseInt(response.body.attrib.nonLetti))
                //this.$emit('changeCounterBacheca', parseInt(response.body.attrib.bacheca))
                // Salvo su vuex il count dei messaggi
                this.$store.commit('set', { key: 'messaggiCount', value: response.body.attrib })
                if (document.documentElement.clientWidth > 1650 && mount && parseInt(response.body.attrib.nonLetti) > 0) {
                  this.$emit('showMessages')
                }
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
              this.$set(this, 'loading', false)
            })
        }, 200)
      },
      setMessaggioService: function (messaggio, operazione, closeModal) {
        let data = new FormData()
        data.append('id', messaggio.id)
        data.append('op', operazione)
        this.$http.post('communication/' + this.$store.state.country + '/messaggio', data)
          .then(response => {
            if (response.body.rc === 0) {
              if (operazione === 'C') {
                this.getMessaggi()
              } else if (operazione === 'P') {
                this.getMessaggi()
              }
              if (closeModal) {
                this.$set(this, 'messageDialogVisible', false)
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      setNotificaService: function (messaggio, operazione) {
        const data = {
          idNotifica: messaggio && messaggio.idNotifica ? messaggio.idNotifica : '',
          operazione: operazione,
          seTutte: messaggio === null ? 'Y' : 'N'
        };
        this.$http.post('pushnotifications/notifica', data, {
        params: {
          codLang: this.codLang,
        }})
          .then(response => {
            if (response.body.rc === 0) {
              this.getMessaggi()
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      changeTab: function (tab, event) {
        this.$set(this, 'showMessaggio', false)
        this.$set(this, 'messaggio', {})
      },
      closeMessages: function () {
        this.$set(this, 'showMessaggio', false)
        this.$set(this, 'messaggio', {})
        this.$emit('closeMessages')
        this.getMessaggi()
      },
      selectMessage: function (item, index) {
        this.$set(this, 'showMessaggio', true)
        this.$set(this, 'messaggio', item)
        if (item.seLetto === 'N') {
          // Richiamo il servizio di Lettura del documento solo l aprima volta
          this.setMessaggioService(item, 'L', false)
        }
      },
      selectNotifica: function (item, index) {
        console.log('selectNotifica')
        this.$set(this, 'showNotifica', true)
        this.$set(this, 'messaggio', item)
        if (item.letta === 'N') {
          this.setNotificaService(item, 'Y')
        }
      },
      closeNotifica: function () {
        this.$set(this, 'showNotifica', false)
        this.$set(this, 'messaggio', {})
        this.$emit('closeMessages')
        //this.getMessaggi()
      },
      formatDate: function (date) {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      },
      openMessageModal: function (ifNonLetto, msg) {
        this.$set(this, 'messageDialogVisible', true)
        this.$set(this, 'msg', msg)
        if (ifNonLetto === true) {
          this.setMessaggioService(msg, 'L', false)
        }
      },
      openNotificaModal: function (msg) {
        this.$set(this, 'notificheDialogVisible', true)
        this.$set(this, 'notifica', msg)
        if (msg.letta === 'N') {
          this.setNotificaService(msg, 'Y')
        }
      },
      closeNotificaModal: function () {
        this.$set(this, 'notificheDialogVisible', false)
        this.$set(this, 'notifica', {
          title: '',
          body: '',
          dataInvio: '',
          dataLettura: ''
        })
      },
      isImportant: function (messaggio, type) {
        if (type === 'NOTIFICHE') {
          if (messaggio.letta === 'Y') {
            return false
          } else {
            return true
          }
        } else if (messaggio.container === undefined) {
          if (messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'Y') {
            // Documenti a cui è stata fatta la Presa Visione
            return false
          } else if (messaggio.sePresaVis === 'N' && messaggio.seLetto === 'Y') {
            // Documenti senza Presa Visione che è già stato letto
            return false
          } else {
            return true
          }
        } else {
          if (messaggio.seLetto === 'Y') {
            return false
          } else {
            return true
          }
        }
      },
      formattedMessageDate(messaggio) {
        // Controllo che messaggio e dataPub esistano
        if (!messaggio || !messaggio.dataPub) return '';

        const d = messaggio.dataPub;

        // Verifica minima sulla lunghezza della data
        if (d.length < 10) return '';

        // Calcola il giorno della settimana
        const dayIndex = new Date(
          d.substr(0, 4),
          parseInt(d.substr(5, 2), 10) - 1,
          d.substr(8, 2)
        ).getDay();

        // Recupera il nome del giorno tradotto
        const dayName = this.$t('messages')[dayIndex];

        // Formatta la data con moment.js
        const formattedDate = moment(d, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm');

        return `${dayName}, ${formattedDate}`;
      },
      formattedNotificationDate(item) {
        if (!item || !item.dataInvio) return '';
        const d = item.dataInvio;

        // Controllo minimo per sicurezza
        if (d.length < 10) return '';

        const dayName = this.$t('messages')[new Date(
          d.substr(0, 4),
          parseInt(d.substr(5, 2)) - 1,
          d.substr(8, 2)
        ).getDay()];

        return dayName + ', ' + moment(d, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm');
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../assets/less/general.less";

  .modalMessaggi {
    &.el-dialog__wrapper {
      .el-dialog {
        .el-dialog__header {
          border-bottom: 0;
          letter-spacing: 2px;
          .set-font(@size: 14px, @family: 'os-semibold', @color: @greenRiva);
        }
        .el-dialog__body {
          .el-tabs {
            .el-tabs__header {
              .el-tabs__nav-wrap {
                border-bottom: 0;
              }
              .el-tabs__item {
                width: 33.33%;
                .barra {
                  height: 4px;
                }
                .counter-nuovi {
                  .el-badge {
                    .el-badge__content {
                      height: 18px;
                      width: 18px;
                      top: 9px;
                      right: -3px;
                      padding: 0;
                      line-height: 16px;
                      .set-font(@color: @white, @size: 10px);
                      letter-spacing: 0;
                      background-color: red;
                    }
                  }
                }
                .counter-bacheca {
                  .el-badge {
                    .el-badge__content {
                      height: 18px;
                      width: 18px;
                      top: 9px;
                      right: -3px;
                      padding: 0;
                      line-height: 16px;
                      .set-font(@color: @white, @size: 10px);
                      letter-spacing: 0;
                      background-color: @oroRiva;
                    }
                  }
                }
              }
            }
            .el-tabs__content {
              .el-tab-pane {
                overflow: auto;
                .elenco-messaggi {
                  height: 460px;
                  overflow: auto;
                  padding-right: 5px !important;
                  .el-card {
                    height: 115px;
                    float: left;
                    margin-bottom: 10px;
                    border-radius: 0px;
                    padding: 5px 10px !important;
                    cursor: pointer;
                    &.important {
                      border-left: 3px solid @greenRiva;
                      .testo {
                        .set-font(@color: @textTable, @size: 12px, @family: 'os-bold') !important;
                      }
                      .footer {
                        .data {
                          .set-font(@color: @greenRiva, @size: 10px, @family: 'os-bold') !important;
                          font-style: normal;
                        }
                      }
                    }
                    .el-card__body {
                      padding: 0;
                      height: 100%;
                      .testata {
                        width: 100%;
                        height: 30px;
                        padding: 0 !important;
                        display: flex;
                        justify-content: space-between;
                        .titolo {
                          width: 80%;
                          .set-font(@family: 'os-semibold', @color: @greenRiva, @size: 14px);
                          text-align: left;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        }
                        .priorita {
                          margin-left: 10px;
                          .fa-icon {
                            color: red;
                          }
                        }
                        .allegati {
                          .fa-icon {
                            color: @greenRiva;
                          }
                        }
                        .ricevuto {
                          .set-font(@color: @greenRiva, @size: 10px);
                          font-style: italic;
                          margin-top: 3px;
                        }
                        .presa-vis {
                          .fa-icon {
                            color: @rossoRiva;
                          }
                        }
                        .presa-vis-yes {
                            .fa-icon {
                            color: @greenTick;
                          }
                        }
                      }
                      .testo {
                        padding: 0 5px !important;
                        .set-font(@size: 12px; @color: @textTable);
                        text-align: left;
                        height: 55px;
                        word-break: break-word;
                      }
                      .footer {
                        display: inline-block;
                        position: absolute;
                        bottom: 6px;
                        left: 0;
                        padding: 0 10px !important;
                        .data {
                          .set-font(@size: 10px);
                          float: left;
                          line-height: 20px;
                          font-style: italic;
                          padding-top: 2px;
                        }
                        .el-button {
                          width: 80px !important;
                          float: right;
                          padding: 0 6px;
                          height: 26px !important;
                        }
                        .skip {
                          float: right;
                          margin-right: 2px;
                          text-align: right;
                          .el-badge {
                            .fa-icon {
                              color: @oroRiva;
                            }
                            .el-badge__content {
                              border: none;
                              background-color: transparent;
                              color: #CBB385;
                              right: 10px;
                            }
                          }
                        }
                      }
                    }
                  }
                }
                .area-messaggio {
                  min-height: 480px;
                  padding-left: 20px;
                  padding: 0 10px 0 0 !important;
                  .msg {
                    height: 100%;
                    border-left: 1px solid #e7e7e7;
                    padding: 0 0 0 20px !important;
                    .titolo {
                      .set-font(@color: @greenRiva, @size: 16px, @family: 'os-semibold');
                      text-align: left;
                      line-height: 20px;
                    }
                    .data {
                      .set-font(@color: @textTable, @size: 12px);
                      margin-top: 15px;
                      text-align: right;
                      font-style: italic;
                    }
                    .priorita {
                      margin-top: 15px;
                      text-align: left;
                      .prior-label {
                        .set-font(@color: @textTable, @size: 14px, @family: 'os-semibold');
                      }
                      .prior-value {
                        margin-left: 2px;
                        .set-font(@color: red, @size: 14px, @family: 'os-semibold');
                      }
                      .prior-icon {
                        .fa-icon {
                          color: red;
                          margin-top: -4px;
                          margin-left: 2px;
                        }
                      }
                    }
                    .testo {
                      margin-top: 20px;
                      .set-font(@color: @textTable, @size: 13px);
                      text-align: justify;
                      height: 230px;
                      overflow: auto;
                      padding-right: 5px !important;
                      word-break: break-word;
                    }
                    .allegati {
                      margin-top: 10px;
                      min-height: 60px;
                      max-height: 110px;
                      overflow: auto;
                      padding-right: 5px !important;
                      .allegato {
                        display: inline-block;
                        .icona {
                          width: 10%;
                          float: left;
                          padding-top: 2px;
                        }
                        .titolo-allegato {
                          width: 85%;
                          float: left;
                          .set-font(@color: @greenRiva, @size: 13px);
                          text-align: left;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        }
                      }
                      .allegato:hover {
                        cursor: pointer;
                      }
                    }
                    .messaggio-footer {
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      height: 35px;
                      .el-button {
                        float: right;
                        height: 30px;
                        line-height: 25px;
                        padding: 0 6px;
                      }
                    }
                  }
                }
              }
              .no-msg {
                margin-top: 20px;
              }
              .box-card:hover {
                cursor: pointer;
              }
              .selected {
                background-color: @hoverTbl;
              }
            }
          }
        }
      }
    }
  }

  .modal-message {
    .el-dialog {
      .el-dialog__body {
        .data {
          width: 100%;
          text-align: right;
          margin-top: 10px;
          .set-font(@size: 12px, @color: @textTable);
          font-style: italic;
          padding: 0 4px !important;
        }
        .priorita {
          margin-top: 15px;
          text-align: left;
          .prior-label {
            .set-font(@color: @textTable, @size: 14px, @family: 'os-semibold');
          }
          .prior-value {
            margin-left: 2px;
            .set-font(@color: red, @size: 14px, @family: 'os-semibold');
          }
          .prior-icon {
            .fa-icon {
              color: red;
              margin-top: -4px;
              margin-left: 2px;
            }
          }
        }
        .testo {
          margin-top: 20px;
          .set-font(@color: @textTable, @size: 13px);
          text-align: justify;
          height: auto;
          overflow: auto;
          padding-right: 5px !important;
          word-break: break-word;
        }
        .allegati {
          min-height: 30px;
          max-height: 120px;
          overflow: auto;
          margin-top: 30px;
          margin-bottom: 20px;
          .allegato {
            display: inline-block;
            .icona {
              width: 10%;
              float: left;
              padding-top: 2px;
            }
            .titolo-allegato {
              width: 85%;
              float: left;
              .set-font(@color: @greenRiva, @size: 13px);
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .allegato:hover {
            cursor: pointer;
          }
        }
      }
      .el-dialog__footer {
        padding: 10px 0 0;
        .footer {
          height: 45px;
          width: 100%;
          padding: 0 !important;
          .scade {
            padding: 10px 0 0 15px;
            .set-font(@color: @textTable, @size: 12px);
            font-style: italic;
          }
        }
      }
    }
  }

  .messages {
    position: absolute;
    top: 76px;
    right: 0px;
    width: 400px;
    .set-font(@size: 14px);
    .titolo {
      height: 30px;
      text-align: center;
      vertical-align: bottom;
      line-height: 30px;
      .set-font(@color: @greenRiva, @family: 'os-semibold', @size: 16px);
      z-index: 10;
    }
    .tabs-class {
      overflow: auto;
    }
    .el-tabs {
      margin-top: 35px;
      .el-tabs__header {
        margin-bottom: 10px;
        height: 30px;
        position: absolute;
        right: 0px;
        top: 30px;
        width: 100%;
        z-index: 10;
        .el-tabs__nav-wrap {
          border-bottom: 0;
        }
        .el-tabs__nav {
          width: 100%;
          height: 35px;
          background-color: #eef4f9;
          .el-tabs__item {
            width: 33.333%;
            background-color: #eef4f9;
            .barra {
              height: 2px;
            }
            .counter-nuovi {
              .el-badge {
                .el-badge__content {
                  height: 20px;
                  width: 20px;
                  top: 9px;
                  right: -3px;
                  padding: 0;
                  line-height: 16px;
                  .set-font(@color: @white, @size: 10px);
                  letter-spacing: 0;
                  background-color: red;
                }
              }
            }
            .counter-bacheca {
              .el-badge {
                .el-badge__content {
                  height: 20px;
                  width: 20px;
                  top: 9px;
                  right: -3px;
                  padding: 0;
                  line-height: 16px;
                  .set-font(@color: @white, @size: 10px);
                  letter-spacing: 0;
                  background-color: @oroRiva;
                }
              }
            }
          }
        }
      }
      .el-tabs__content {
        overflow: auto;
        .messaggio {
          box-shadow: 1px 1px 12px 1px rgba(0, 0, 0, 0.2);
          transition: 0.3s;
          border-radius: 0;
          width: 97%;
          height: 120px;
          background-color: @white;
          margin: auto;
          margin-bottom: 5px;
          margin-top: 10px;
          &.important {
            border-left: 3px solid @greenRiva;
            .testo {
              .set-font(@color: @textTable, @size: 12px, @family: 'os-bold') !important;
            }
            .footer {
              .data {
                .set-font(@color: @greenRiva, @size: 10px, @family: 'os-bold') !important;
                font-style: normal;
              }
            }
          }
          .testata {
            width: 100%;
            height: 30px;
            padding: 0 15px;
            display: flex;
            justify-content: space-between;
            .titolo {
              width: 80%;
              .set-font(@family: 'os-semibold', @color: @greenRiva, @size: 14px);
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .priorita {
              margin-top: 2px;
              margin-left: 10px;
              .fa-icon {
                color: red;
              }
            }
            .allegati {
              margin-top: 3px;
              .fa-icon {
                color: @greenRiva;
              }
            }
            .ricevuto {
              .set-font(@color: @greenRiva, @size: 11px);
              font-style: italic;
              margin-top: 6px;
            }
            .presa-vis {
              .fa-icon {
                color: @rossoRiva;
              }
            }
            .presa-vis-yes {
                .fa-icon {
                color: @greenTick;
              }
            }
          }
          .testo {
            padding: 6px 20px;
            .set-font(@color: @textTable, @size: 12px);
            line-height: 16px;
            height: 60px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
          }
          .footer {
            width: 100%;
            height: 30px;
            padding: 0 15px;
            display: flex;
            justify-content: space-between;
            .data {
              .set-font(@color: @greenRiva, @size: 11px);
              font-style: italic;
              height: 20px;
              line-height: 20px;
            }
            .el-button {
              width: 80px !important;
              float: right;
              padding: 0 6px;
              height: 26px !important;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Messages.vue